import gql from "graphql-tag";

const ADD_NON_EVM_WALLET_MUTATION = gql`
    mutation addWallet(
        $address: String!
        $blockchain: String!
    ) {
        addWallet(
            addWalletInput: {
                address: $address
                blockchain: $blockchain
            }
        )   {
            id
            address
            blockchain
        }
    }
`;

export default ADD_NON_EVM_WALLET_MUTATION;